export default __webpack_public_path__ + "f19474bf1f3abc97bf0a35bfce31daae.svg";